import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import { usePageView } from 'hooks'
import { THEME, getStaticWrapper } from 'utils'

const DownloadPage = () => {
  usePageView()
  return (
    <SiteLayout background='#FFFFFF'>
      <div className='appPage'>
        <Head
          title='The Barstool Sports App | iPhone, Android, Apple TV, Roku, Fire TV,  Android TV | Barstool Sports'
          description='Download our new apps for Barstool Sports to enjoy on your Apple, Android, Roku, Fire TV and other devices wherever you are.'
        />
        <section className='appPage__section appPage__section--white'>
          <div className='container'>
            <h1 className='appPage__label'>Barstool Sports Apps</h1>
            <h2 className='appPage__title'>
              Wherever you are,
              <br />
              so are we.
            </h2>
            <div className='appPage__platforms'>
              <a
                href='https://apps.apple.com/us/app/barstool-sports/id456805313#?platform=iphone'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src='/static/images/download/ios.png' alt='Barstool on iOS' />
              </a>
              <a
                href='https://play.google.com/store/apps/details?id=com.DesignMenace.BarstoolSports&hl=en_US'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src='/static/images/download/android.png' alt='Barstool on Android' />
              </a>
              <a
                href='https://apps.apple.com/us/app/barstool-sports/id456805313#?platform=appleTV'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src='/static/images/download/apple-tv.png' alt='Barstool on Apple TV' />
              </a>
              <a
                href='https://channelstore.roku.com/details/297579/barstool-sports'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src='/static/images/download/roku.png' alt='Barstool on Roku' />
              </a>
              <a
                href='https://www.amazon.com/dp/B07V6MRB3C/ref=cm_sw_em_r_mt_dp_U_9HesDbH7NVDQE'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src='/static/images/download/fire-tv.png' alt='Barstool on Fire TV' />
              </a>
              <a
                href='https://play.google.com/store/apps/details?id=com.maz.combo2223&hl=en_US'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src='/static/images/download/android-tv.png' alt='Barstool on Android TV' />
              </a>
              <img src='/static/images/download/chromecast.png' alt='Barstool on Chromecast' />
            </div>
          </div>
        </section>
        <section className='appPage__section appPage__section--screens'>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <h2 className='appPage__sectionTitle'>Download the Barstool Sports mobile app</h2>
                <p>5 stars for a reason. 50k reviews and counting.</p>
                <div className='appPage__apps'>
                  <a
                    href='https://apps.apple.com/us/app/barstool-sports/id456805313#?platform=iphone'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src='/static/images/download-app-store.svg' alt='Barstool Sports on iOS' />
                  </a>
                  <a
                    href='https://play.google.com/store/apps/details?id=com.DesignMenace.BarstoolSports&hl=en_US'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src='/static/images/download-play-store.svg' alt='Barstool on Android' />
                  </a>
                </div>
              </div>
              <div className='col'>
                <img className='appPage__screens' src='/static/images/download/screens.png' alt='Barstool Sports App' />
                <img
                  className='appPage__screens-sm'
                  src='/static/images/download/screens-sm.png'
                  alt='Barstool Sports App'
                />
              </div>
            </div>
          </div>
        </section>
        <section className='appPage__section appPage__section--ott appPage__section--white'>
          <div className='container'>
            <h2 className='appPage__sectionTitle textCenter'>Watch on the big screen</h2>
            <p className='textCenter'>
              Enjoy Barstool Sports videos on your television using streaming apps or devices.
            </p>
            <img className='appPage__ott' src='/static/images/download/ott.png' alt='Barstool Sports App' />
            <div className='row row--slim'>
              <div className='col--3 appPage__device'>
                <img src='/static/images/download/devices/apple-tv.png' alt='Barstool Sports on Apple TV' />
                <p>Apple TV App</p>
                <a
                  href='https://apps.apple.com/us/app/barstool-sports/id456805313#?platform=appleTV'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Download
                </a>
              </div>
              <div className='col--3 appPage__device'>
                <img src='/static/images/download/devices/roku.png' alt='Barstool Sports on Roku' />
                <p>Roku Channel</p>
                <a
                  href='https://channelstore.roku.com/details/297579/barstool-sports'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Download
                </a>
              </div>
              <div className='col--3 appPage__device'>
                <img src='/static/images/download/devices/fire-tv.png' alt='Barstool Sports on Fire TV' />
                <p>Amazon Fire TV</p>
                <a
                  href='https://www.amazon.com/dp/B07V6MRB3C/ref=cm_sw_em_r_mt_dp_U_9HesDbH7NVDQE'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Download
                </a>
              </div>
              <div className='col--3 appPage__device'>
                <img src='/static/images/download/devices/android-tv.png' alt='Barstool Sports on Android TV' />
                <p>Android TV</p>
                <a
                  href='https://play.google.com/store/apps/details?id=com.maz.combo2223&hl=en_US'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Download
                </a>
              </div>
            </div>
            <div className='row row--slim'>
              <div className='col--3 col--spacer' />
              <div className='col--3 appPage__device appPage__device--sm'>
                <img src='/static/images/download/devices/airplay.png' alt='Barstool on Airplay' />
                <p>AirPlay</p>
              </div>
              <div className='col--3 appPage__device appPage__device--sm'>
                <img src='/static/images/download/devices/chromecast.png' alt='Barstool on Chromecast' />
                <p>Chromecast</p>
              </div>
              <div className='col--3 col--spacer' />
            </div>
          </div>
        </section>
      </div>
      <style jsx>{`
        .textCenter {
          text-align: center;
        }
        .appPage .container {
          max-width: 1030px;
          padding: 0 15px;
        }
        .appPage .row {
          display: flex;
          flex: 0 1 auto;
          flex-direction: row;
          flex-wrap: wrap;
          margin-right: -0.9375rem;
          margin-left: -0.9375rem;
        }
        .appPage .row--slim {
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }
        .appPage .col {
          flex-basis: 100%;
          max-width: 100%;
          padding-right: 0.9375rem;
          padding-left: 0.9375rem;
        }
        @media (min-width: 47.9375rem) {
          .appPage .col {
            flex-basis: 50%;
            max-width: 50%;
            padding-right: 0.9375rem;
            padding-left: 0.9375rem;
          }
        }
        .appPage .col--3 {
          flex-basis: 50%;
          max-width: 50%;
          padding-right: 0.9375rem;
          padding-left: 0.9375rem;
        }
        @media (min-width: 47.9375rem) {
          .appPage .col--3 {
            flex-basis: 25%;
            max-width: 25%;
            padding-right: 0.9375rem;
            padding-left: 0.9375rem;
          }
        }
        .appPage .col--spacer {
          display: none;
        }
        @media (min-width: 47.9375rem) {
          .appPage .col--spacer {
            display: block;
          }
        }
        .appPage__section {
          padding: 0 0 40px;
        }
        .appPage__section p {
          font-size: 14px;
          font-weight: 400;
          color: ${THEME.COLORS.TEXTCOLOR};
          letter-spacing: 0.1px;
          line-height: 20px;
        }
        .appPage__sectionTitle {
          font-size: 32px;
          font-weight: 700;
          color: ${THEME.COLORS.TEXTCOLOR};
          letter-spacing: -0.1px;
          line-height: 33px;
          text-transform: none;
        }
        .appPage__section--white {
          background: white;
        }
        .appPage__section--screens {
          background: #f1f1f1;
          padding-bottom: 0;
          text-align: center;
          padding-top: 40px;
        }
        @media (min-width: 47.9375rem) {
          .appPage__section--screens .appPage__sectionTitle {
            margin-top: 70px;
          }
        }
        @media (min-width: 47.9375rem) {
          .appPage__section--screens {
            text-align: left;
            padding-bottom: 40px;
          }
        }
        .appPage__section--ott p {
          max-width: 330px;
          margin-left: auto;
          margin-right: auto;
          padding-bottom: 0;
        }
        .appPage__label {
          font-size: 12px;
          font-weight: 700;
          color: #999;
          letter-spacing: 0.6px;
          line-height: 15px;
          text-transform: uppercase;
          text-align: center;
        }
        .appPage__title {
          font-size: 40px;
          font-weight: 700;
          margin: 0 0 0.5rem;
          color: ${THEME.COLORS.TEXTCOLOR};
          letter-spacing: -0.1px;
          line-height: 45px;
          text-transform: none;
          text-align: center;
        }
        .appPage__platforms,
        .appPage__apps {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: 50px 0 0;
        }
        .appPage__platforms img,
        .appPage__apps img {
          display: block;
          width: auto;
          height: 22px;
        }
        .appPage__platforms {
          margin: 25px 0 0;
        }
        .appPage__platforms img {
          margin: 15px 10px;
        }
        @media (min-width: 47.9375rem) {
          .appPage__platforms img {
            margin: 25px 25px 0;
          }
        }
        .appPage__apps {
          justify-content: center;
          margin: 35px 0 0 0;
        }
        .appPage__apps img {
          height: 44px;
          margin: 0 5px;
        }
        @media (min-width: 47.9375rem) {
          .appPage__apps img {
            height: 50px;
            margin: 0 15px 0 0;
            justify-content: left;
          }
        }
        @media (min-width: 47.9375rem) {
          .appPage__apps {
            justify-content: left;
          }
        }
        .appPage__screens {
          display: none;
          max-width: 100%;
        }
        @media (min-width: 47.9375rem) {
          .appPage__screens {
            display: block;
          }
        }
        .appPage__screens-sm {
          display: block;
          width: 100%;
          max-width: 230px;
          margin: 30px auto 0;
        }
        @media (min-width: 47.9375rem) {
          .appPage__screens-sm {
            display: none;
          }
        }
        .appPage__ott {
          display: block;
          width: 100%;
          max-width: 800px;
          margin: 40px auto;
        }
        .appPage__device {
          text-align: center;
          margin-bottom: 30px;
        }
        .appPage__device img {
          display: block;
          height: 110px;
          width: auto;
          margin: 0 auto 20px;
        }
        .appPage__device--sm img {
          height: 30px;
        }
        .appPage__device p {
          font-size: 16px;
          font-weight: 700;
          color: ${THEME.COLORS.TEXTCOLOR};
          line-height: 19px;
          margin: 0;
        }
        .appPage__device a {
          display: block;
          margin-top: 5px;
          font-size: 14px;
          font-weight: 400;
          color: ${THEME.COLORS.LINKCOLOR};
        }
      `}</style>
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default DownloadPage
